import { co2 } from './common';

export default {
  'consumption.co2': `การปลดปล่อยก๊าซ${co2} รวมกัน`,
  'consumption.energy': 'การใช้พลังงานต่อรอบการทดลอง',
  'consumption.fuel': 'การสิ้นเปลืองเชื้อเพลิงทั้งหมดรวมกัน',
  'footnotes.local': '',
  'footnotes.wltp': '',
  'footnotes.nedc': '',
  'footnotes.emissions.appendix':
    'สำหรับข้อมูลเพิ่มเติมเกี่ยวกับการสิ้นเปลืองเชื้อเพลิง และการปลดปล่อยก๊าซ CO2 ของรถยนต์ กรุณาติดต่อผู้จำหน่ายเมอร์เซเดส-เบนซ์อย่างเป็นทางการ',
  'search.input.label': 'ค้นหา',
  'search.result.buy-online': 'ซื้อรถออนไลน์',
  'search.results': 'ไม่พบข้อมูล | {count} ผลการค้นหา | {count} ผลการค้นหา',
  'search.results.backup': 'ไม่พบข้อมูลที่ตรงตามการค้นหา พบเนื้อหาใกล้เคียงด้านล่าง:',
  'search.results.none.summary': 'ไม่พบข้อมูลสำหรับการการค้นหานี้ กรุณาลองใหม่อีกครั้ง',
  'search.results.count': '{count} ผลการค้นหา',
  'search.show-more': 'แสดงผลเพิ่มเติม',
  'search.unavailable': 'การค้นหาไม่สามารถใช้งานได้ในขณะนี้',
  'search.result.new': 'ใหม่',
  'input.placeholder': 'ค้นหา',

  'suggestions.all_search_results': 'ผลลัพธ์การค้นหาทั้งหมด',
  'suggestions.all_search_results_for': 'แสดงผลลัพธ์ทั้งหมดสำหรับ',
  'suggestions.in': 'ใน',

  all: 'ทั้งหมด',
  UCOS: 'ร้านค้าออนไลน์สำหรับรถยนต์มือสอง',
  PASSENGER_CARS: 'รถยนต์ส่วนบุคคล',
  VANS: 'รถตู้',
  NCOS: 'ร้านค้าออนไลน์สำหรับรถยนต์ใหม่',
  VIDEO: 'วิดีโอ',
  DEALER_LOCATOR: 'การค้นหาตัวแทนจำหน่าย',
  CONFIGURATOR: 'ออกแบบรถของคุณ',
  TEST_DRIVE: 'ทดลองขับ',
  VEHICLE_SEARCH: 'ค้นหารถยนต์มือสอง',
  COLLECT: 'คอลเลกชันและอุปกรณ์ตกแต่ง',
  CONNECT: 'Mercedes me Store',
  ACCESSORIES: 'อุปกรณ์ตกแต่งรถยนต์',

  'search.result.consumption': 'อัตราการสิ้นเปลือง',
  'watch.video': 'รับชมวิดีโอ',
  'input.recently': 'ที่ค้นหาล่าสุด',
  'input.help.title': 'คุณควรค้นหาจากอะไร?',
  'input.help.text': 'ค้นหาโดยระบุประเภทรถยนต์ รุ่นรถยนต์ รหัสการกำหนดค่า หรืออุปกรณ์เสริม ผลิตภัณฑ์และข้อมูลอื่นๆ',

  'search.result.grid': 'ตาราง',
  'search.result.list': 'รายการ',

  // No results
  'support.check': 'โปรดตรวจสอบดูว่าสะกดผิดหรือไม่ หรือลองอีกครั้งโดยใช้คำอื่น',
  'support.no.results': 'คำค้นนี้ไม่มีผลลัพธ์ที่ใช้ได้',
  'support.no.results.term': 'ไม่พบผลลัพธ์',
  'support.chat': 'หากไม่พบสิ่งที่ต้องการค้นหา โปรดใช้ช่องทางช่วยเหลือผ่านการแช',
  'support.chat.with.us': 'ทออนไลน์ของเรา.',

  'search.results.offer': 'ข้อเสนอที่เป็นที่นิยมสําหรับ "{query}":',
};
